import React, { useEffect, useState } from "react";
import { Button, Table, message, Space, Input } from "antd";
import axios from "axios";
import { getConfig } from "../../../../../config";
import { UndoOutlined } from "@ant-design/icons";

const { API_BASE_URL } = getConfig();

interface OGLApprovalProps {
    selectedProject: string;
    oglCodes: OGLCode[];
    setOglCodes: (data: OGLCode[]) => void;
}

const OGLApproval: React.FC<OGLApprovalProps> = ({ selectedProject, oglCodes, setOglCodes }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [editedDescriptions, setEditedDescriptions] = useState<{ [key: string]: string }>({});

    const handleReset = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get<OGLCode[]>(
                `${API_BASE_URL}/getNetworkPlanOGLCodes?auth=VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU&projectNo=${selectedProject}`
            );
            setOglCodes(response.data);
            setEditedDescriptions({}); // Lokale Änderungen zurücksetzen
        } catch (error) {
            message.error("Fehler beim Laden der Daten.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDescriptionChange = (ogl: string, newValue: string) => {
        setEditedDescriptions((prev) => ({
            ...prev,
            [ogl]: newValue,
        }));
    };

    const handleDescriptionSave = (ogl: string) => {
        const updatedOglCodes = oglCodes.map((code) =>
            code.ogl === ogl ? { ...code, description: editedDescriptions[ogl] || code.description } : code
        );
        setOglCodes(updatedOglCodes);
        setEditedDescriptions((prev) => {
            const { [ogl]: _, ...rest } = prev; // Gespeicherten Wert aus lokalem State entfernen
            return rest;
        });
    };

    const columns = [
        { title: "OGL", dataIndex: "ogl", key: "ogl", width: 150 },
        {
            title: "Beschreibung",
            dataIndex: "description",
            key: "description",
            width: 300,
            render: (text: string, record: OGLCode) => (
                <Input
                    value={editedDescriptions[record.ogl] ?? text}
                    onChange={(e) => handleDescriptionChange(record.ogl, e.target.value)}
                    onBlur={() => handleDescriptionSave(record.ogl)}
                />
            ),
        },
    ];

    return (
        <div style={{ padding: "20px" }}>
            <Space style={{ marginBottom: 16, display: "flex", justifyContent: "flex-end" }}>
                <Button
                    icon={<UndoOutlined />}
                    type="primary"
                    onClick={handleReset}
                    loading={isLoading}
                >
                    Daten neu laden
                </Button>
            </Space>
            <Table
                columns={columns}
                dataSource={oglCodes}
                rowKey="ogl"
                pagination={{ pageSize: 100 }}
                loading={isLoading}
            />
        </div>
    );
};

export default OGLApproval;
